import { css } from 'lit';

var css_248z = css`:host{--progress-height:1rem;--progress-font-size:0.75rem;display:block}.progress{height:var(--progress-height)}`;

export { css_248z as default };
//# sourceMappingURL=sgds-progress2.js.map
